import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import { ImageItemCover } from '../libs/ImageItemCover';
import { cloudflareCDN } from 'ui';
import { getUrlFromRef } from '../libs/firebase';
import { useLoadProjectFromCollection } from './CollectionLoadProject';
import { useProjectDataFetcher } from '../hooks/useProjectDataFetcher';

export function CollectionUserProjects(props) {
	let currentUserUid = props?.currentUserUid;
    const loadProjectFromCollection = useLoadProjectFromCollection();
    const { fetchProjectData } = useProjectDataFetcher();
    const [boardData, setBoardData] = useState(null);
    const [loading, setLoading] = useState(false);

    const getImageSrc = (board) => {
        const thumbnail = board.thumbnail || board.files.screenshot;
    	const url =  getUrlFromRef(thumbnail);		
		return cloudflareCDN(url, 'width=400,format=auto');
	}

    useEffect(() => {
        const fetchBoardData = async () => {
            if (props.associatedBoardUrl) {
                setLoading(true);
                const boardId = props.associatedBoardUrl.split('/').pop();
                try {
                    // get the board data from the database using useLoadProjectFromCollection
                    const data = await fetchProjectData(boardId);
                    setBoardData(data);
                } catch (error) {
                    console.error('Error loading board data:', error);
                    setBoardData(null);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchBoardData();
    }, [props.associatedBoardUrl]);

    // Determine what to render: new single project or legacy projects array
    const renderMode = props.associatedBoardUrl ? 'single' : 'legacy';
    const projects = renderMode === 'single' ? [boardData].filter(Boolean) : (props.projects || []);

    const handleProjectClick = (project) => {
        if (renderMode === 'single' && boardData) {
            // For new approach: use cached data to avoid refetching
            loadProjectFromCollection({ id: boardData.id }, false, boardData);
        } else {
            // For legacy approach: use original behavior
            loadProjectFromCollection(project);
        }
    };
    
    if (loading) return <div>Loading...</div>;
    if (!projects || projects.length === 0) return null;

    return (
        <>
        {projects.map((item, index) => (
            <Grid key={item.id || index} item xs={12} sx={{ marginBottom: '10px' }} >               
                <ImageItemCover 
                    id={item.id} 
                    name={item?.projectData?.title || item?.name} 
                    src={getImageSrc(item)}
                    draggable={false} 
                    onClick={() => handleProjectClick(item)}
                    currentUserUid={currentUserUid}
                    type='templates'
                    showInfoText={true}
                    infoText='Click to load this template'
                />	
            </Grid>
        ))}
        </>
    );
}
